var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import React, { useState } from 'react';
import { Button, GBTypography } from '@leapfinance/geebee-component-library';
import MenuOpenIcon from '@mui/icons-material/MenuOpen';
import { Menu, MenuItem } from '@mui/material';
var ButtonDropdown = function (_a) {
    var handleMenuSelect = _a.handleMenuSelect, _b = _a.label, label = _b === void 0 ? 'Select Option' : _b, _c = _a.options, options = _c === void 0 ? [] : _c, buttonProps = _a.buttonProps;
    var _d = __read(useState(null), 2), anchorEl = _d[0], setAnchorEl = _d[1];
    var isMenuOpen = Boolean(anchorEl);
    var handleMenuClick = function (event) {
        setAnchorEl(event.currentTarget);
    };
    var handleMenuClose = function () {
        setAnchorEl(null);
    };
    var handleClick = function (value) {
        handleMenuSelect === null || handleMenuSelect === void 0 ? void 0 : handleMenuSelect(value);
        handleMenuClose();
    };
    return (React.createElement(React.Fragment, null,
        React.createElement("div", { style: {
                display: 'flex',
                width: '100%',
                justifyContent: 'end'
            } },
            React.createElement(Menu, { id: "sorting-btn", anchorEl: anchorEl, open: isMenuOpen, onClose: handleMenuClose }, options.map(function (eachOption) { return (React.createElement(MenuItem, { key: eachOption.id, value: eachOption.order === 'DESC' ? 'decreasing' : 'increasing', onClick: function () {
                    handleClick === null || handleClick === void 0 ? void 0 : handleClick(__assign({}, eachOption));
                } },
                React.createElement(GBTypography, { variant: "body4" }, eachOption.label))); }))),
        React.createElement(Button, __assign({ variant: "tertiary", style: { textTransform: 'none' }, disableElevation: true, startIcon: React.createElement(MenuOpenIcon, null), "aria-haspopup": "true", "aria-expanded": isMenuOpen ? 'true' : undefined, onClick: handleMenuClick, size: "small" }, buttonProps), label)));
};
export default ButtonDropdown;
//# sourceMappingURL=ButtonDropdown.js.map